import { gql } from "apollo-boost";
import { client } from "../../index";

export default async data => {
  await client.mutate({
    mutation: gql`
      mutation DeleteExpertService(
          $id: ID!
        ){
        deleteExpertService(where: {
          id: $id
        }) {
          id
        }
      }
    `,
    variables: data
  });
};
